import { styled } from '@mui/material/styles'
import { Toolbar } from '@mui/material'

export const PageToolbar = styled(Toolbar)<{ backgroundColor?: string }>(
  ({ theme, backgroundColor }) => ({
    backgroundColor: backgroundColor || theme.palette.neutral000,
    color: backgroundColor
      ? theme.palette.neutral000
      : theme.palette.neutral900,
    borderBottom: '1px solid',
    borderColor: theme.palette.neutral300,
    height: '56px',
  }),
)
